<template>
  <div class="page">
    <div class="ctrl">共 {{ list.length }} 条</div>
    <a-table
      class="sec"
      size="small"
      :rowKey="(record) => record.id"
      bordered
      :columns="columns"
      :data-source="list"
      :pagination="false"
    >
    </a-table>

    <p style="padding: 0 15px">注：出价次数每个人对每个拍品只计算了一次，与普通拍卖不同</p>

    <div style="padding: 0 15px">
      <a-button :disabled="page <= 1" icon="left" @click="next(-1)"></a-button>
      <span style="margin: 0 10px">{{page}}</span>
      <a-button icon="right" @click="next(1)"></a-button>
    </div>
  </div>
</template>

<style lang='scss' scoped>
</style>

<script>
const columns = [
  {
    title: "#",
    dataIndex: "id",
  },
  {
    title: "场次",
    dataIndex: "title",
  },
  {
    title: "开始时间",
    dataIndex: "start_at",
  },
  {
    title: "商品数量",
    dataIndex: "goods_amount",
  },
  {
    title: "出价次数",
    dataIndex: "bid_amount",
  },
  {
    title: "参与人数",
    dataIndex: "user_amount",
  },
  {
    title: "赢家人数",
    dataIndex: "winner_amount",
  },
  {
    title: "订单数量",
    dataIndex: "order_amount",
  },
  {
    title: "未付款订单数量",
    dataIndex: "unpay_amount",
  },
  {
    title: "订单总额（元）",
    dataIndex: "total",
  }
];


export default {
  data() {
    return {
      columns,
      list: [],
      page: 1
    };
  },

  created() {
    this.getData();
  },

  methods: {
    next (e) {
      this.page += e
    },
    async getData() {
      const r = await this.$axios.get("/tuanpai/tongji?page=" + this.page);
      if(r.status == 1) this.list = r.list
    },
  },
};
</script>